import React from 'react';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';
import Header from "../../components/header";
import Footer from '../../components/footer';
import Images from '../../assests';

const Privacy = () => {
    return (
        <>
            <Header />
            <Box
                sx={{
                    width: '100%',
                    height: '300px',
                    backgroundImage: `url(${Images.trainSchedule})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative'
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderRadius: 2,
                    }}
                ></Box>
                <Typography variant="h3" align="center" sx={{ padding: "30px 0", fontSize: '25px', color: 'white', zIndex: 1 }}>
                    Privacy Policy
                </Typography>
            </Box>

            <Divider />

            <Container sx={{ margin: "0 auto", pt: "50px", maxWidth: "1000px", px: { lg: 0, xs: "40px" } }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '48px', textAlign: 'center', mb: 4 }}>
                    Privacy Policy – Track My Trains
                </Typography>
                <Typography paragraph>
                    <strong>Effective Date:</strong> December 24, 2024<br />
                    <strong>Last Updated:</strong> June 6, 2025
                </Typography>
                <Typography paragraph>
                    Thank you for choosing Track My Trains. This Privacy Policy explains our practices regarding your information.
                </Typography>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>Key Facts About Our Data Practices:</Typography>
                <ul>
                    <li>🔒 <strong>We do NOT collect any user data directly</strong></li>
                    <li>📍 <strong>No location access</strong> (approximate or precise)</li>
                    <li>📱 <strong>No contacts, files, or device information access</strong></li>
                    <li>📊 <strong>No in-app analytics or crash reports by us</strong></li>
                    <li>📧 <strong>No personal identifiers collected or stored by us</strong></li>
                </ul>

                <Typography paragraph>
                    <strong>Important Note:</strong> Track My Trains is an independent third-party app, not affiliated with any government agency or railway authority.
                </Typography>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>1. Information Collection</Typography>
                <Typography paragraph>
                    We do not collect or store any personal or sensitive user data through our app. The application:
                </Typography>
                <ul>
                    <li>Does not request any permissions on your device</li>
                    <li>Does not access your location, contacts, or identity</li>
                    <li>Does not maintain any user accounts or require logins</li>
                </ul>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>2. Third-Party Services (AdMob)</Typography>
                <Typography paragraph>
                    While we do not collect data ourselves, our app uses third-party SDKs, specifically:
                </Typography>
                <ul>
                    <li><strong>AdMob by Google</strong> for displaying ads</li>
                </ul>
                <Typography paragraph>
                    AdMob may collect certain information automatically for delivering and improving ads, including:
                </Typography>
                <ul>
                    <li>Device Advertising ID</li>
                    <li>IP address and basic device information</li>
                    <li>Non-personal usage data and diagnostics</li>
                </ul>
                <Typography paragraph>
                    For more details, refer to <a href="https://support.google.com/admob/answer/6128543" target="_blank">AdMob’s Privacy Policy</a>.
                </Typography>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>3. Data Handling</Typography>
                <ul> 
                    <li>We operate no backend servers or user databases</li>
                    <li>No data is collected, stored, or transmitted by us</li>
                </ul>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>4. Advertising & Consent</Typography>
                <ul>
                    <li>Ads are served using Google's <strong>non-personalized ad network</strong> (where applicable)</li>
                    <li>Users can opt out of ad personalization in Android settings:</li>
                </ul>
                <Typography paragraph>
                    <em>Android Settings → Google → Ads → Opt out of Ads Personalization</em>
                </Typography>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>5. Children’s Privacy</Typography>
                <Typography paragraph>
                    Our app is not targeted at children under 13. We do not knowingly collect any data from children.
                </Typography>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>6. Policy Updates</Typography>
                <Typography paragraph>
                    We may update this policy in the future. Any changes will be reflected by the “Last Updated” date above.
                </Typography>

                <Typography variant="h5" sx={{ fontSize: '25px', mb: 2 }}>7. Contact Us</Typography>
                <Typography paragraph>
                    For any questions or concerns, contact us at: <strong><a href="mailto:trackkmytrain@gmail.com">trackkmytrain@gmail.com</a></strong>
                </Typography>
            </Container>

            <Footer />
        </>
    );
};

export default Privacy;